import { useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { SupplierDashboardScreen } from '@/routes/supplier/dashboard/dashboard-screen';

// =============================================================================
// dashboard-route.tsx — Adaptateur routeur du TABLEAU DE BORD FOURNISSEUR (DBU §3.2, D3b).
// =============================================================================
// La navigation est portée ici ; le composant de présentation reste testable hors routeur. Aucun
// état métier en localStorage (RULE_REF_006).

export function SupplierDashboardRoute(): React.JSX.Element {
  const navigate = useNavigate();

  // GATE_HUMAN 2026-09-12 : « Reprendre » ouvre la CAMPAGNE (détail + grille de saisie embarquée) via
  // /campagnes?campaign=<id>, plus la page /saisie autonome. Le cycle courant est géré dans la campagne.
  const onOpenCampaign = React.useCallback(
    (campaignId: string): void => {
      void navigate({ to: '/campagnes', search: { campaign: campaignId } });
    },
    [navigate],
  );

  return <SupplierDashboardScreen onOpenCampaign={onOpenCampaign} />;
}
